var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "263px",
    height: "180px",
    viewBox: "0 0 263 180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u753B\u677F 1 \u526F\u672C 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F-1-\\u526F\\u672C-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.680898,172.134971 L245.680898,172.088322 L17.3191021,172.088322 L17.3191021,172.134971 C4.1756355,124.062517 22.6288286,72.9207194 63.4547484,44.2730949 C104.280668,15.6254703 158.70999,15.6254703 199.53591,44.2730949 C240.36183,72.9207194 258.815023,124.062517 245.671556,172.134971 L245.680898,172.134971 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,172.078992 L263,172.078992 C263,176.453644 259.449208,180 255.069084,180 L7.9215742,180 C3.54509894,179.994852 0,176.450003 0,172.078992 L263,172.078992 L263,172.078992 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D9D8EF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#E7E6F4",
    x: 94.9654756,
    y: 168.710931,
    width: 71.9200469,
    height: 3.36806095
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#DCDCEF",
    x: 117.515806,
    y: 148.558545,
    width: 26.5858493,
    height: 20.1523869
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#E7E6F4",
    x: 56.8709242,
    y: 53.4971233,
    width: 148.342687,
    height: 95.0614212
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#DCDCEF",
    x: 62.3263479,
    y: 68.6767221,
    width: 32.6391277,
    height: 68.9846058
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 62.3263479,
    y: 58.6378479,
    width: 137.422498,
    height: 10.0295444
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 98.1696029,
    y: 102.096097,
    width: 59.2156354,
    height: 35.5559011
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 98.1696029,
    y: 72.4646245,
    width: 101.588584,
    height: 26.6925828
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 160.477268,
    y: 102.096097,
    width: 39.2809192,
    height: 35.5559011
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E7E6F4",
    points: "216.236556 42.7771731 216.236556 73.6681698 182.364353 73.6681698 182.364353 33.9791634 206.40932 33.9791634 206.40932 42.7771731"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#D9D8EF",
    points: "216.236556 42.7771731 206.40932 42.7771731 206.40932 33.9791634"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D9D8EF",
    x: 188.071997,
    y: 48.29109,
    width: 23.2509413,
    height: 8.72337117
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D9D8EF",
    x: 188.071997,
    y: 60.9609703,
    width: 23.2509413,
    height: 2.0245685
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D9D8EF",
    x: 188.071997,
    y: 66.7174623,
    width: 17.141614,
    height: 2.0245685
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.536087,36.0130617 L107.772643,36.0130617 C107.772643,36.0130617 128.482702,9.35779817 131.210414,9.35779817 C133.938126,9.35779817 154.536087,36.0130617 154.536087,36.0130617 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#DCDCEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.478547,36.0130617 C136.61913,37.9350023 134.209029,39.315814 131.369219,39.315814 C128.52941,39.315814 126.119308,37.9350023 125.259892,36.0130617 L137.478547,36.0130617 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#E7E6F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#DBDAF2",
    x: 130.687291,
    y: 0,
    width: 1,
    height: 9.35779817
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#D9D8EF",
    cx: 131.621439,
    cy: 142.90468,
    rx: 2.55022377,
    ry: 2.54703779
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D9D8EF",
    x: 183.578745,
    y: 142.90468,
    width: 24.259821,
    height: 24.2295133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5536691,154.389675 L33.3303971,152.523713 C32.2949143,151.661084 30.9449928,151.27108 29.6083155,151.448371 C28.2716382,151.625663 27.0704259,152.35404 26.2962634,153.456694 C24.5101392,155.982668 24.7976724,159.424821 26.9781914,161.620277 L32.0692974,166.761001 L37.151062,166.761001 L35.5536691,154.389675 Z M31.6582724,154.566941 L33.0875186,155.742497 L34.1804717,164.139325 L33.1622505,164.139325 L28.8371457,159.772975 C27.5359177,158.481588 27.3657191,156.437803 28.4354621,154.949464 C28.7923969,154.446808 29.3431636,154.11572 29.9549882,154.036017 C30.5668127,153.956313 31.1841843,154.135225 31.6582724,154.529622 L31.6582724,154.566941 Z",
    id: "\\u5F62\\u72B6",
    fill: "#E7E6F4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E7E6F4",
    points: "31.6956383 144.061577 54.5822618 144.061577 51.4435249 174.430104 35.6190595 174.430104"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D9D8EF",
    x: 71.7986077,
    y: 62.9855388,
    width: 17.8889323,
    height: 2.42575027,
    rx: 1.21287514
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 75.7033459,
    y: 74.2186285,
    width: 15.2172693,
    height: 2.42575027,
    rx: 1.21287514
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#F9F8FF",
    cx: 70.2572636,
    cy: 75.4315037,
    rx: 2.97059032,
    ry: 2.96687918
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 187.184556,
    y: 150.629762,
    width: 17.141614,
    height: 1.4927694
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#F9F8FF",
    x: 187.184556,
    y: 154.865495,
    width: 12.6390211,
    height: 1.4927694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.517298,118.078059 C131.481317,118.078059 129.005825,115.969523 129.005825,113.413155 C128.965871,112.963018 129.183742,112.528913 129.568754,112.291527 C129.953766,112.054141 130.439962,112.054141 130.824973,112.291527 C131.209985,112.528913 131.427856,112.963018 131.387902,113.413155 C131.387902,114.663349 132.82649,115.726948 134.517298,115.726948 C136.208105,115.726948 137.646693,114.663349 137.646693,113.413155 C137.606739,112.963018 137.82461,112.528913 138.209622,112.291527 C138.594634,112.054141 139.08083,112.054141 139.465841,112.291527 C139.850853,112.528913 140.068724,112.963018 140.02877,113.413155 C140.056795,115.969523 137.581303,118.078059 134.517298,118.078059 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D9D8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.887618,118.078059 C118.851637,118.078059 116.376145,115.969523 116.376145,113.413155 C116.336192,112.963018 116.554063,112.528913 116.939074,112.291527 C117.324086,112.054141 117.810282,112.054141 118.195294,112.291527 C118.580306,112.528913 118.798176,112.963018 118.758223,113.413155 C118.758223,114.663349 120.19681,115.726948 121.887618,115.726948 C123.578426,115.726948 125.017014,114.663349 125.017014,113.413155 C124.97706,112.963018 125.194931,112.528913 125.579942,112.291527 C125.964954,112.054141 126.45115,112.054141 126.836162,112.291527 C127.221174,112.528913 127.439045,112.963018 127.399091,113.413155 C127.399091,115.969523 124.923599,118.078059 121.887618,118.078059 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D9D8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.600341,124.786192 C116.085417,124.792753 115.635761,124.439434 115.520953,123.938055 C115.406144,123.436677 115.657333,122.923275 116.123926,122.705645 C123.441191,118.977261 132.104309,118.977261 139.421574,122.705645 C139.869968,123.039889 139.993208,123.65837 139.70711,124.138606 C139.421012,124.618842 138.817979,124.805729 138.309938,124.571606 C131.623635,121.246867 123.76306,121.246867 117.076756,124.571606 C116.937282,124.679932 116.773964,124.753493 116.600341,124.786192 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#D9D8EF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLight);
export default __webpack_public_path__ + "static/media/NoData_light.86adbb6de2544348410fdc7e6bd02ff9.svg";
export { ForwardRef as ReactComponent };